const enumStringConstructor = (words) => {
	if (words.every((word) => typeof word === "string")) {
		const string = words.join(", ");
		return string[0].toUpperCase() + string.slice(1);
	}
};
export default enumStringConstructor;
